/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationPersonalLoanRequest as ModelsV4ApplicationApplicationPersonalLoanRequest } from '../../models/Models/v4/Application/application-personal-loan-request';
import { ApplicationUpdatePersonalResponseBaseResponse as ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse } from '../../models/Models/v4/Application/Public/application-update-personal-response-base-response';

export interface V4PublicApplicationPersonalApplicationIdPut$Plain$Params {
  applicationId: string;
      body?: ModelsV4ApplicationApplicationPersonalLoanRequest
}

export function v4PublicApplicationPersonalApplicationIdPut$Plain(http: HttpClient, rootUrl: string, params: V4PublicApplicationPersonalApplicationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationPersonalApplicationIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdatePersonalResponseBaseResponse>;
    })
  );
}

v4PublicApplicationPersonalApplicationIdPut$Plain.PATH = '/v4/public/application/personal/{applicationId}';
